import React, { useState } from 'react';
import { Box, Toolbar, useTheme } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const theme = useTheme();

  const handleMenuClick = () => {
    setSidebarOpen(true);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        position: 'relative',
        backgroundColor: 'transparent',
      }}
    >
      <Header onMenuClick={handleMenuClick} />
      <Sidebar open={sidebarOpen} onClose={handleSidebarClose} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          px: { xs: 1.5, sm: 2, md: 3, lg: 4 },
          pb: { xs: 4, md: 6 },
          pt: { xs: 4, md: 6 },
          overflow: 'hidden',
          maxWidth: '100%',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background:
              theme.palette.mode === 'dark'
                ? 'radial-gradient(circle at 15% 20%, rgba(61, 101, 245, 0.15), transparent 55%), radial-gradient(circle at 85% 10%, rgba(192, 132, 87, 0.16), transparent 45%)'
                : 'none', // Light 테마에서는 그라데이션 제거
            pointerEvents: 'none',
            zIndex: 0,
          },
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 56, sm: 64 }, mb: { xs: 2, md: 3 } }} />

        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            flexGrow: 1,
            width: '100%',
            maxWidth: 'min(1320px, 100%)',
            mx: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 2.5, md: 3.5 },
            overflow: 'hidden',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
